import React from 'react';

import { formatNumber } from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/utils/number-formatter';

import { SimpleHorizon } from '../simple-horizon-selector/SimpleHorizonSelector';
import * as S from './PriceReturnPill.styles';

interface PriceReturnPillProps {
  horizon: SimpleHorizon;
  tsValue?: number;
}

export const PriceReturnPill = ({ horizon, tsValue }: PriceReturnPillProps) => {
  if (tsValue === undefined) {
    return null;
  }

  const value = formatNumber({
    isPercentage: true,
    value: tsValue,
    addPlus: true,
  });
  const isNegative = tsValue < 0;

  return (
    <S.RightHeaderWrapper $isNegative={isNegative}>
      <S.RightHeaderReturnLabel>{horizon}</S.RightHeaderReturnLabel>
      <S.RightHeaderReturnValue $isNegative={isNegative}>
        {value}
      </S.RightHeaderReturnValue>
    </S.RightHeaderWrapper>
  );
};
